// extracted by mini-css-extract-plugin
module.exports = {"appMain":"app_appMain__1jq9b"};